import { Input } from 'antd';
import RangeInputCustom from 'components/molecules/common/RangeInput';
import React, { useContext, useEffect, useState } from 'react';
import { OptimisationPlanData } from '../OptimizePlan';
import { UserContext } from 'contexts/ConfigContext';
import { formatNumWithKMBAlt, getConfig } from 'utils/helperMethods';
import _ from 'lodash';
import RangeInputWithPopover from 'components/molecules/common/RangeInpuWithPopover';
interface IProps {
    rowData: OptimisationPlanData;
    setTableData: React.Dispatch<React.SetStateAction<OptimisationPlanData[]>>;
    index: number;
}
export enum InputTypes {
    Range = 'range',
    Text = 'text',
}
const OptimizeTableContent: React.FC<IProps> = ({ rowData, setTableData, index }) => {
    const { appConfig } = useContext(UserContext);
    const commonConfig = getConfig('commonConfig', appConfig);
    const { decimalForPercentage, decimalForNonPercentage } = commonConfig ?? {};
    const { min_value, max_value, default_value, type, label, name, originalValue } = rowData;
    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target;
        setTableData((prev) => {
            prev[index].single_value = Number(value);
            return [...prev];
        });
    };

    const handleRangeChange = (value: number | null, min: boolean) => {
        setTableData((prev) => {
            min ? (prev[index].min_value = Number(value)) : (prev[index].max_value = Number(value));
            return [...prev];
        });
    };

    const getInputComponent = (inputType: InputTypes, name: string) => {
        switch (inputType) {
            case InputTypes.Range: {
                return (
                    <RangeInputWithPopover
                        maxVal={max_value}
                        minVal={min_value}
                        onMaxChange={(val) => {
                            handleRangeChange(val, false);
                        }}
                        onMinChange={(val) => {
                            handleRangeChange(val, true);
                        }}
                    />
                );
            }
            case InputTypes.Text: {
                return (
                    <Input
                        className="!border !border-[rgba(217, 217, 217, 1)] !rounded-md !w-40"
                        onChange={handleInputChange}
                        name={name}
                        value={default_value ?? undefined}
                        type="number"
                    />
                );
            }
        }
    };
    const isPercentage = label?.includes('%');
    const decimalType = isPercentage ? decimalForPercentage : decimalForNonPercentage;
    return (
        <div className="flex justify-between gap-4 p-4 border-b border-[rgba(240,240,240,1)] last:border-none items-center">
            <span className="flex-1">{label}</span>
            <span className="flex-1">{formatNumWithKMBAlt(originalValue ?? 0, decimalType)}</span>
            <div className="flex-1">{getInputComponent(type, name)}</div>
        </div>
    );
};

export default OptimizeTableContent;
